// Единый набор контурных (line) иконок мини-аппа. Inline-SVG, без
// внешних зависимостей: stroke = currentColor, поэтому иконка
// наследует цвет родителя и корректно работает в светлой/тёмной
// темах Telegram. Используется в навигации (TabBar, кластеры
// «Обмена») вместо разнородных эмодзи.

import { ReactNode } from "react";

export type IconName =
  | "card"
  | "export"
  | "swap"
  | "check"
  | "grid"
  | "coins"
  | "ledger"
  | "list";

const PATHS: Record<IconName, ReactNode> = {
  // Платежи — банковская карта.
  card: (
    <>
      <rect x="2" y="5" width="20" height="14" rx="2.5" />
      <path d="M2 10h20" />
    </>
  ),
  // Экспорт — коробка-посылка.
  export: (
    <>
      <path d="M21 8l-9-5-9 5v8l9 5 9-5z" />
      <path d="M3 8l9 5 9-5M12 13v8" />
    </>
  ),
  // Обмен — встречные стрелки.
  swap: (
    <>
      <path d="M3 9h15M14 5l4 4-4 4" />
      <path d="M21 15H6M10 11l-4 4 4 4" />
    </>
  ),
  // Задачи — галочка в круге.
  check: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12l3 3 5-6" />
    </>
  ),
  // Ещё — сетка разделов.
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </>
  ),
  // Крипта — монета.
  coins: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 8.5h4a2 2 0 010 4h-4M9.5 12.5h4.7a2 2 0 010 4H8.5M11 6v12" />
    </>
  ),
  // Учёт / расчёты — журнал.
  ledger: (
    <>
      <path d="M5 4a2 2 0 012-2h12v18H7a2 2 0 00-2 2z" />
      <path d="M5 4v16M10 7h6M10 11h6" />
    </>
  ),
  // Реестр — список со строками-чек-маркерами.
  list: (
    <>
      <path d="M8 6h13M8 12h13M8 18h13" />
      <circle cx="4" cy="6" r="1.5" />
      <circle cx="4" cy="12" r="1.5" />
      <circle cx="4" cy="18" r="1.5" />
    </>
  ),
};

export function Icon({
  name,
  size = 22,
  className,
}: {
  name: IconName;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}
